import { useMutation } from '@tanstack/react-query'
import { useToolsStore } from '@/store'

export const useCheckMailSettings = () => {
  const { checkMailSettings } = useToolsStore()

  return useMutation({
    mutationFn: (params: Parameters<typeof checkMailSettings>[0]) => checkMailSettings(params),
    throwOnError: false
  })
}
